import React, {useEffect, useContext, useState} from 'react';
import {useParams, useHistory} from 'react-router-dom';
import farmerContext from "../../context/farmer/farmerContext";
import {useAlert} from "react-alert";
import {PaystackConsumer} from 'react-paystack';
import Swal from "sweetalert2";


const Checkout = () => {

    const FarmerContext = useContext(farmerContext);
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const history = useHistory();
    const alert = useAlert()
    const {createEquipmentRequest, getEquipments, farmer, getFarms, log_farmer_equipment_request} = FarmerContext;
    const {purchaseData, equipments} = farmer;
    let {id} = useParams();
    const [showResults, setShowResults] = useState(false)
    const [farmSize, setFarmSize] = useState(1);

    const config = {
        reference: purchaseData.payment_reference,
        email: userInfo.email,
        amount: purchaseData.initial_deposit * 100,
        publicKey: 'pk_test_bf5cd1ee94c0c13b38631acc24c647d9dc1f0b1a',
    };

    // you can call this function anything
    const handleSuccess = (reference) => {
        // Implementation for whatever you want to do with reference and after success call.
        log_farmer_equipment_request(purchaseData.payment_reference)
        history.push("/farmer/success")
        alert.show(
            "Service Purchase Successful"
        )
    };

    // you can call this function anything
    const handleClose = () => {
        console.log("closed")
        // implementation for  whatever you want to do when the Paystack dialog closed.
        history.push(`/farmer/checkout/${id}`)
    }

    const componentProps = {
        ...config,
        text: 'Starting Payment',
        onSuccess: (reference) => handleSuccess(reference),
        onClose: handleClose
    };
    const submitHandler = (e) => {
        e.preventDefault();
        let purchase_form = document.getElementById("purchase_form")

        let purchase_data = new FormData(purchase_form);
        purchase_data.append('equipmentservice_setting_id', id)
        createEquipmentRequest(purchase_data)
        setShowResults(true)

    };

    const regenerate = () => {
        setShowResults(false)
    }

    const isCompleteProfile = userInfo.is_profile_complete;

    useEffect(() => {
        if (parseInt(isCompleteProfile) !== 1) {
            history.push("/farmer/profile")
            Swal.fire({
                icon: 'info',
                title: "Update Profile",
                text: "You need to complete your profile before making a Service Request",
            })
        } else if (farmer.farms.length === 0) {
            //Get all farmers farms when the component mounts
            getFarms().then(farmer_farms => {
                if (farmer_farms.length === 0) {
                    history.push("/farmer/farm/add")
                    Swal.fire({
                        icon: 'info',
                        title: "Add a Farm",
                        text: "You need to add a Farm before making a Service Request",
                    })
                }

            })
        }

        if (farmer.equipments.length === 0) {
            getEquipments(id)
        }


        //eslint-disable-next-line
    }, [equipments]);

    return (
        <div className="content-wrapper">
            <div className="container-fluid">
                <h3 className="make-bold">Payment Summary</h3>

                <div className="dashboard-inner-view">
                    <div className="row mt-5">
                        <div className="col-lg-6">
                            {showResults ?
                                (<div className="card p-3">
                                    <h6>Confirm Payment Summary Before Clicking Pay</h6>
                                    <div className="card-body d-flex flex-column h-100">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <p className="mb-0"><strong>To be Payed By</strong></p>
                                            <p className="mb-0">
                                                <strong>{userInfo.first_name + " " + userInfo.last_name}</strong></p>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <p className="mb-0">Equipment transportation fee</p>
                                            <p className="mb-0">₦{Number(parseFloat(purchaseData.equipment_transportation_cost)).toLocaleString()}</p>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <p className="mb-0">Operator fee</p>
                                            <p className="mb-0">₦{Number(parseFloat(purchaseData.operator_fee)).toLocaleString()}</p>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <p className="mb-0">Balance</p>
                                            <p className="mb-0">₦{Number(parseFloat(purchaseData.balance)).toLocaleString()}</p>
                                        </div>
                                        <div className="py-3">
                                            <hr></hr>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <p className="mb-0">Initial Deposit</p>
                                            <p className="mb-0">₦{Number(parseFloat(purchaseData.initial_deposit)).toLocaleString()}</p>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <p className="mb-0">Grand total</p>
                                            <p className="mb-0">₦{Number(parseFloat(purchaseData.grand_total)).toLocaleString()}</p>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center text-dark-green">
                                            <h5 className="text-dark-green">Total</h5>
                                            <h5 className="make-bold text-dark-green">₦{Number(parseFloat(purchaseData.initial_deposit)).toLocaleString()}</h5>
                                        </div>
                                        <div className="mt-3">
                                            <button type='submit' onClick={regenerate}
                                                    className="btn btn-orange btn-block text-white">Re-Generate Invoice
                                            </button>
                                        </div>
                                        <div className="mt-2">
                                            <PaystackConsumer {...componentProps} >
                                                {({initializePayment}) => <button type='submit'
                                                                                  className="btn btn-gravity-secondary text-white make-medium btn-block"
                                                                                  onClick={() => initializePayment(handleSuccess, handleClose)}>Pay</button>}
                                            </PaystackConsumer>
                                        </div>
                                    </div>
                                </div>) : (
                                    <div className="card p-3">
                                        <h6>Please, Complete This Form Beform Making Payment</h6>
                                        <form onSubmit={submitHandler} id="purchase_form">

                                            <div className="form-group mb-5">
                                                <label>Farm Name</label>
                                                <select className="form-control " name="farm_id" id="farm_id">
                                                    {farmer.farms !== null && farmer.farms.map(farm => (
                                                        <option value={farm.id} key={farm.id}>{farm.farm_name}</option>
                                                    ))
                                                    }
                                                </select>
                                            </div>

                                            <div className="form-group mb-5">
                                                <label>Start Date</label>
                                                <input type="date" name="start_time"
                                                       className="form-control form-control-custom-view"
                                                       required/>
                                            </div>

                                            <div className="form-group mb-5">
                                                <label>End Date</label>
                                                <input type="date" name="end_time"
                                                       className="form-control form-control-custom-view"
                                                       required/>
                                            </div>

                                            <div className="form-group mb-5">
                                                <label className="form-check-label">Do You need an Operator?</label>
                                                <select className="form-control" name="operator_status" required>
                                                    <option>--Choose--</option>
                                                    <option value="1">Yes</option>
                                                    <option value="0">No</option>
                                                </select>
                                            </div>

                                            <div className="form-group mb-5">
                                                <label>Do You Want To Use The Original Farm Size?</label>
                                                <select className="form-control" name="isOriginal"
                                                        onChange={e => setFarmSize(e.target.value)} required>
                                                    <option>--Choose--</option>
                                                    <option value="1">Yes</option>
                                                    <option value="0">No</option>
                                                </select>
                                            </div>

                                            {farmSize === "0" && <div className="form-group mb-5">
                                                <label>Enter the farm Size</label>
                                                <input type="text" name="farm_size"
                                                       className="form-control form-control-custom-view"
                                                       required/>
                                            </div>}

                                            <div className="mt-5">
                                                <button type='submit'
                                                        className="btn btn-orange btn-block text-white">Generate Receipt
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                )}
                        </div>
                        <div className="col-lg-5">
                            <h6>List of services tools images.</h6>
                            <div className="grid-tools">
                                {equipments.length > 0 ? equipments.map((equipment, index) => (
                                    <div className="grid-tool-item" key={index}>
                                        <div className="card-image-holder-idea-4 bord-rad-10">
                                            <img src={equipment.equipment.image}
                                                 className="card-img-top w-100 h-100 obj-fit" alt="..."/>
                                        </div>
                                    </div>
                                )) : (<p>No image to display</p>)}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}


export default Checkout